// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { useTranslation } from 'react-i18next';
import { AddAssignment, GetAssignmentByPersonId } from '../../../../store/HR/Person/assignmentSlice.js';
import { CardFooter } from '../../../../components/card/card.jsx';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions';
import showConfirmation from '../../../../components/Shared/Alert/Confirmation';

// function AssignmentForm({
//   AssignmentListById,
//   Data,
//   Grade,
//   Group,
//   Organization,
//   Jobs,
//   Position,
//   Payroll,
//   Locations,
//   SuperVisor,
//   Status,
//   allAssignment
// }) {
//   const { HasPermission } = usePermissions();
//   const { id } = useParams();

//   const Navigate = useNavigate();
//   const { t, i18n } = useTranslation();
//   const dispatch = useDispatch();

//   const isCurrent = allAssignment?.find(item => item.id === AssignmentListById.id)?.isCurrent;

//   //______________________________________________________________________________________________________
//   const formik = useFormik({
//     initialValues: {
//       id: '',
//       startDate: AssignmentListById?.startDate ?? '',
//       // endDate: "",
//       gradeId: AssignmentListById.gradeId ?? null,
//       positionId: AssignmentListById.positionId ?? '',
//       jobId: AssignmentListById.jobId ?? '',
//       assignmentStatusTypeId: AssignmentListById.assignmentStatusTypeId ?? '',
//       payrollId: AssignmentListById.payrollId ?? '',
//       locationId: AssignmentListById.locationId ?? '',
//       supervisorId: AssignmentListById.supervisorId ?? '',
//       // personId: "",
//       organizationId: AssignmentListById.organizationId ?? '',
//       personGroupId: AssignmentListById.personGroupId ?? ''
//       // managerFlag: false,
//       // normalHours: 2,
//       // rotationPlanId: null,
//       // isNewAssignment: true
//     },
//     enableReinitialize: true,
//     // validationSchema: AssignmentFormSchema(t),
//     onSubmit: (values, { resetForm }) => {
//       if (values.startDate <= AssignmentListById?.startDate) {
//         CustomAlert({
//           action: 'info',
//           msg: 'لا يمكن تعيين الموظف في نفس تاريخ التعيين السابق او قبله ',
//           Timer: 10000
//         });
//         return;
//       }

//       showConfirmation('هل انت متأكد من اضافة تعيين جديد لهذا الموظف', () => {
//         dispatch(
//           AddAssignment({
//             id: null,
//             startDate: values.startDate,
//             endDate: null, // when add assingment always value = null  every case
//             gradeId: values.gradeId,
//             positionId: values.positionId || null, //
//             jobId: values.jobId || null,
//             assignmentStatusTypeId: values.assignmentStatusTypeId || null,
//             payrollId: values.payrollId || null,
//             locationId: values.locationId || null,
//             supervisorId: values.supervisorId || null,
//             personId: id,
//             organizationId: values.organizationId || null,
//             personGroupId: values.personGroupId || null,
//             managerFlag: false,
//             normalHours: 0,
//             // rotationPlanId: null,
//             isNewAssignment: true // عندما يكون تعيين جديد تكون القيمة true
//           })
//         )
//           .unwrap()
//           .then(() => {
//             CustomAlert({ action: 'Add', msg: 'تمت عملية تعيين الموظف بنجاح' });
//             dispatch(GetAssignmentByPersonId(id));
//             // resetForm();
//             // Navigate(-1, { replace: true });
//           })
//           .catch(error => {
//             CustomAlert({ action: 'Error' });
//             formik.setSubmitting(false);
//           });
//       });
//     }
//   });
//   const { values, errors, touched, setFieldValue } = formik;

//   /// handle Update Assignment
//   const handleUpdateAssignment = () => {
//     const msg =
//       i18n.language === 'en'
//         ? 'Are you sure you want to update the assignment for this employee?'
//         : 'هل أنت متأكد من تعديل التعيين لهذا الموظف';
//     showConfirmation(msg, () => {
//       dispatch(
//         AddAssignment({
//           id: Data.id,
//           startDate: formik.values.startDate,
//           endDate: null, // when add assingment always value = null  every case
//           gradeId: formik.values.gradeId,
//           positionId: formik.values.positionId,
//           jobId: formik.values.jobId,
//           assignmentStatusTypeId: formik.values.assignmentStatusTypeId,
//           payrollId: formik.values.payrollId || null,
//           locationId: formik.values.locationId,
//           supervisorId: formik.values.supervisorId,
//           personId: id,
//           organizationId: formik.values.organizationId,
//           personGroupId: formik.values.personGroupId,
//           managerFlag: formik.values.managerFlag,
//           normalHours: formik.values.normalHours,
//           rotationPlanId: null,
//           isNewAssignment: false // عندما يكون تعيين جديد تكون القيمة true
//         })
//       )
//         .unwrap()
//         .then(() => {
//           CustomAlert({ action: 'Edit' });
//           Navigate('/HR/Employees', { replace: true });
//         })
//         .catch(error => {
//           CustomAlert({ action: 'Error' });
//           formik.setSubmitting(false);
//         });
//     });
//   };

//   // console.log(Position.list);

//   return (
//     <>
//       <Form>
//         <div className='row'>
//           <div className='col-xl-4'>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('Department')}</label>
//               <Select
//                 classNamePrefix='react-select'
//                 isSearchable={true}
//                 name='organizationId'
//                 options={Organization.list}
//                 onChange={option => setFieldValue('organizationId', option.value)}
//                 value={values.organizationId ? Organization.list?.find(f => f.value === values.organizationId) : null}
//                 placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                 required
//               />
//               {errors.organizationId && touched.organizationId && (
//                 <div style={{ color: 'red' }}>{errors.organizationId}</div>
//               )}
//             </div>
//           </div>

//           <div className='col-xl-4'>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('Job')}</label>
//               <Select
//                 classNamePrefix='react-select'
//                 isSearchable={true}
//                 name='jobId'
//                 required
//                 options={Jobs.list}
//                 onChange={option => setFieldValue('jobId', option.value)}
//                 value={Jobs.list?.find(f => f.value === values.jobId)}
//                 placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//               />
//               {errors.jobId && touched.jobId && <div style={{ color: 'red' }}>{errors.jobId}</div>}
//             </div>
//           </div>

//           <div className='col-xl-4'>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('location')}</label>
//               <Select
//                 classNamePrefix='react-select'
//                 isSearchable={true}
//                 name='locationId'
//                 options={Locations.list}
//                 onChange={option => setFieldValue('locationId', option.value)}
//                 value={Locations.list?.find(f => f.value === values.locationId)}
//                 placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//               />
//               {errors.locationId && touched.locationId && <div style={{ color: 'red' }}>{errors.locationId}</div>}
//             </div>
//           </div>

//           <div className='col-xl-4'>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('Position')}</label>

//               <Select
//                 classNamePrefix='react-select'
//                 isSearchable={true}
//                 name='positionId'
//                 required
//                 options={Position?.list?.filter(
//                   f =>
//                     f?.organizationId === values.organizationId &&
//                     f.locationId === values.locationId &&
//                     f.jobId === values.jobId
//                 )}
//                 onChange={option => setFieldValue('positionId', option.value)}
//                 value={Position.list?.find(f => f.value === values.positionId)}
//                 placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                 // formatOptionLabel={(option) => (
//                 //   <div className="d-flex justify-content-between   ">
//                 //     <div className="">{option.label}</div>
//                 //     <div className="text-theme fw-bold">
//                 //       {option.filledHeadcount >= option.headcount ? 'مكتمل':''}
//                 //     </div>
//                 //     <div className="text-theme fw-bold">
//                 //       {option.filledHeadcount + '/' + option.headcount}
//                 //     </div>
//                 //   </div>
//                 // )}
//                 formatOptionLabel={option => (
//                   <div
//                     className={`d-flex justify-content-between align-items-center ${
//                       option.filledHeadcount >= option.headcount ? 'option-full' : ''
//                     }`}
//                   >
//                     <div className=''>{option.label}</div>
//                     <div className='text-theme fw-bold'>
//                       {option.filledHeadcount >= option.headcount ? (
//                         <span className='badge bg-danger mx-2'>
//                           {i18n.language === 'ar' ? 'غير متاح' : 'Not Available'}
//                           {/* {i18n.language === 'ar' ? 'لا يوجد شاغر' : 'No Vacancy'} */}
//                         </span>
//                       ) : (
//                         ''
//                       )}

//                       <span className='text-theme fw-bold '>{option.filledHeadcount + '/' + option.headcount}</span>
//                     </div>
//                   </div>
//                 )}
//                 getOptionDisabled={option => option.filledHeadcount >= option.headcount}
//               />

//               {errors.positionId && touched.positionId && <div style={{ color: 'red' }}>{errors.positionId}</div>}
//             </div>
//           </div>

//           <div className='col-xl-4'>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('group')}</label>

//               <Select
//                 classNamePrefix='react-select'
//                 isSearchable={true}
//                 name='personGroupId'
//                 required
//                 options={Group.list}
//                 onChange={option => setFieldValue('personGroupId', option.value)}
//                 value={Group.list?.find(f => f.value === values.personGroupId)}
//                 placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//               />
//               {errors.personGroupId && touched.personGroupId && (
//                 <div style={{ color: 'red' }}>{errors.personGroupId}</div>
//               )}
//             </div>
//           </div>
//           <div className='col-xl-4'>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('Grade')}</label>

//               <Select
//                 classNamePrefix='react-select'
//                 isSearchable={true}
//                 name='gradeId'
//                 required
//                 options={Grade.list}
//                 onChange={option => setFieldValue('gradeId', option.value)}
//                 value={Grade.list?.find(f => f.value === values.gradeId)}
//                 placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//               />
//               {errors.gradeId && touched.gradeId && <div style={{ color: 'red' }}>{errors.gradeId}</div>}
//             </div>
//           </div>

//           <div className='col-xl-4'>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('SuperVisor')}</label>
//               <Select
//                 classNamePrefix='react-select'
//                 isSearchable={true}
//                 name='supervisorId'
//                 options={SuperVisor.list}
//                 onChange={option => setFieldValue('supervisorId', option.value)}
//                 value={SuperVisor.list?.find(f => f.value === values.supervisorId)}
//                 placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//               />
//               {errors.supervisorId && touched.supervisorId && <div style={{ color: 'red' }}>{errors.supervisorId}</div>}
//             </div>
//           </div>

//           <div className='col-xl-4'>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('Payroll')}</label>

//               <Select
//                 classNamePrefix='react-select'
//                 isSearchable={true}
//                 name='payrollId'
//                 required
//                 options={Payroll.list}
//                 onChange={option => setFieldValue('payrollId', option.value)}
//                 value={Payroll.list?.find(f => f.value === values.payrollId)}
//                 placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//               />
//               {errors.payrollId && touched.payrollId && <div style={{ color: 'red' }}>{errors.payrollId}</div>}
//             </div>
//           </div>
//           <div className='col-xl-4'>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('Status')}</label>
//               <Select
//                 classNamePrefix='react-select'
//                 isSearchable={true}
//                 name='assignmentStatusTypeId'
//                 required
//                 options={Status.list}
//                 onChange={option => setFieldValue('assignmentStatusTypeId', option.value)}
//                 value={Status.list?.find(f => f.value === values.assignmentStatusTypeId)}
//                 placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//               />
//               {errors.assignmentStatusTypeId && touched.assignmentStatusTypeId && (
//                 <div style={{ color: 'red' }}>{errors.assignmentStatusTypeId}</div>
//               )}
//             </div>
//           </div>
//         </div>
//         <div className='row'>
//           <div className='col-xl-5 m-auto'>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('Start Date')}</label>
//               <Form.Control
//                 type='date'
//                 className='form-c ontrol'
//                 name='startDate'
//                 onChange={formik.handleChange}
//                 value={formik.values.startDate}
//                 // isInvalid={!!formik.errors.startDate}
//               />

//               {formik.errors.startDate && formik.touched.startDate && (
//                 <div style={{ color: 'red' }}>{formik.errors.startDate}</div>
//               )}

//               {/* <Form.Control.Feedback type="invalid">
//                 {formik.errors.startDate && formik.touched.startDate}
//               </Form.Control.Feedback> */}
//             </div>
//           </div>

//           <div className='col-xl-5 m-auto'>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('End_Date')}</label>
//               <Form.Control
//                 type='date'
//                 className='form-control'
//                 name='endDate'
//                 onChange={formik.handleChange}
//                 value={formik.values.endDate}
//                 isInvalid={formik.errors.endDate && formik.touched.endDate}
//               />
//               <Form.Control.Feedback type='invalid'>{formik.errors.endDate}</Form.Control.Feedback>
//             </div>
//           </div>
//         </div>
//       </Form>

//       <CardFooter>
//         <div className='row'>
//           <div className='col-10 m-auto'>
//             <div className='text-center'>
//               {(isCurrent || isCurrent === undefined) && (
//                 <>
//                   {allAssignment?.length > 0 && (
//                     <>
//                       {HasPermission('EditHrPerAssignment') && (
//                         <button onClick={e => handleUpdateAssignment(e)} type='button' className=' btn me-1 btn-theme '>
//                           <i className='fas fa-lg fa-fw me-2 fa-pen-square me-1'></i>
//                           {t('Edit_Aassignment')}
//                         </button>
//                       )}
//                     </>
//                   )}
//                 </>
//               )}
//               <button
//                 onClick={() => Navigate('/HR/Employees', { replace: true })}
//                 type='button'
//                 className=' btn me-1 btn-default '
//               >
//                 <i className='fa fa-power-off fa-fw me-1'></i>
//                 {t('Cancel')}
//               </button>
//             </div>
//           </div>
//           <div className='col-2'>
//             <div className='text-end'>
//               {(isCurrent || isCurrent === undefined) && HasPermission('AddHrPerAssignment') && (
//                 <button onClick={formik.handleSubmit} type='button' className=' btn me-1 btn-theme'>
//                   <i className='fa fa-plus-circle fa-fw me-1'></i>
//                   {t('NewAssignments')}
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       </CardFooter>
//     </>
//   );
// }


function AssignmentForm({
  AssignmentListById,
  Data,
  Grade,
  Group,
  Organization,
  Jobs,
  Position,
  Payroll,
  Locations,
  SuperVisor,
  Status,
  allAssignment
}) {
  const { HasPermission } = usePermissions();
  const { id } = useParams();

  const Navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const isCurrent = allAssignment?.find(item => item.id === AssignmentListById.id)?.isCurrent;

  const formik = useFormik({
    initialValues: {
      id: '',
      startDate: AssignmentListById?.startDate ?? '',
      gradeId: AssignmentListById.gradeId ?? null,
      positionId: AssignmentListById.positionId ?? '',
      jobId: AssignmentListById.jobId ?? '',
      assignmentStatusTypeId: AssignmentListById.assignmentStatusTypeId ?? '',
      payrollId: AssignmentListById.payrollId ?? '',
      locationId: AssignmentListById.locationId ?? '',
      supervisorId: AssignmentListById.supervisorId ?? '',
      organizationId: AssignmentListById.organizationId ?? '',
      personGroupId: AssignmentListById.personGroupId ?? ''
    },
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      if (values.startDate <= AssignmentListById?.startDate) {
        CustomAlert({
          action: 'info',
          msg: 'لا يمكن تعيين الموظف في نفس تاريخ التعيين السابق او قبله ',
          Timer: 10000
        });
        return;
      }

      showConfirmation('هل انت متأكد من اضافة تعيين جديد لهذا الموظف', () => {
        dispatch(
          AddAssignment({
            id: null,
            startDate: values.startDate,
            endDate: null,
            gradeId: values.gradeId,
            positionId: values.positionId || null,
            jobId: values.jobId || null,
            assignmentStatusTypeId: values.assignmentStatusTypeId || null,
            payrollId: values.payrollId || null,
            locationId: values.locationId || null,
            supervisorId: values.supervisorId || null,
            personId: id,
            organizationId: values.organizationId || null,
            personGroupId: values.personGroupId || null,
            managerFlag: false,
            normalHours: 0,
            isNewAssignment: true
          })
        )
          .unwrap()
          .then(() => {
            CustomAlert({ action: 'Add', msg: 'تمت عملية تعيين الموظف بنجاح' });
            dispatch(GetAssignmentByPersonId(id));
          })
          .catch(error => {
            CustomAlert({ action: 'Error' });
            formik.setSubmitting(false);
          });
      });
    }
  });
  const { values, errors, touched, setFieldValue } = formik;

  const handleUpdateAssignment = () => {
    const msg =
      i18n.language === 'en'
        ? 'Are you sure you want to update the assignment for this employee?'
        : 'هل أنت متأكد من تعديل التعيين لهذا الموظف';
    showConfirmation(msg, () => {
      dispatch(
        AddAssignment({
          id: Data.id,
          startDate: formik.values.startDate,
          endDate: null,
          gradeId: formik.values.gradeId,
          positionId: formik.values.positionId,
          jobId: formik.values.jobId,
          assignmentStatusTypeId: formik.values.assignmentStatusTypeId,
          payrollId: formik.values.payrollId || null,
          locationId: formik.values.locationId,
          supervisorId: formik.values.supervisorId,
          personId: id,
          organizationId: formik.values.organizationId,
          personGroupId: formik.values.personGroupId,
          managerFlag: formik.values.managerFlag,
          normalHours: formik.values.normalHours,
          rotationPlanId: null,
          isNewAssignment: false
        })
      )
        .unwrap()
        .then(() => {
          CustomAlert({ action: 'Edit' });
          Navigate('/HR/Employees', { replace: true });
        })
        .catch(error => {
          CustomAlert({ action: 'Error' });
          formik.setSubmitting(false);
        });
    });
  };

  return (
    <>
      <Form>
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="form-label fw-semibold">{t('Department')}</label>
            <Select
              classNamePrefix="react-select"
              isSearchable={true}
              name="organizationId"
              options={Organization.list}
              onChange={option => setFieldValue('organizationId', option.value)}
              value={values.organizationId ? Organization.list?.find(f => f.value === values.organizationId) : null}
              placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
              className={errors.organizationId && touched.organizationId ? 'is-invalid' : ''}
            />
            {errors.organizationId && touched.organizationId && (
              <div className="invalid-feedback d-block">{errors.organizationId}</div>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label fw-semibold">{t('Job')}</label>
            <Select
              classNamePrefix="react-select"
              isSearchable={true}
              name="jobId"
              options={Jobs.list}
              onChange={option => setFieldValue('jobId', option.value)}
              value={Jobs.list?.find(f => f.value === values.jobId)}
              placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
              className={errors.jobId && touched.jobId ? 'is-invalid' : ''}
            />
            {errors.jobId && touched.jobId && <div className="invalid-feedback d-block">{errors.jobId}</div>}
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label fw-semibold">{t('location')}</label>
            <Select
              classNamePrefix="react-select"
              isSearchable={true}
              name="locationId"
              options={Locations.list}
              onChange={option => setFieldValue('locationId', option.value)}
              value={Locations.list?.find(f => f.value === values.locationId)}
              placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
              className={errors.locationId && touched.locationId ? 'is-invalid' : ''}
            />
            {errors.locationId && touched.locationId && <div className="invalid-feedback d-block">{errors.locationId}</div>}
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label fw-semibold">{t('Position')}</label>
            <Select
              classNamePrefix="react-select"
              isSearchable={true}
              name="positionId"
              options={Position?.list?.filter(
                f =>
                  f?.organizationId === values.organizationId &&
                  f.locationId === values.locationId &&
                  f.jobId === values.jobId
              )}
              onChange={option => setFieldValue('positionId', option.value)}
              value={Position.list?.find(f => f.value === values.positionId)}
              placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
              className={errors.positionId && touched.positionId ? 'is-invalid' : ''}
              formatOptionLabel={option => (
                <div
                  className={`d-flex justify-content-between align-items-center ${
                    option.filledHeadcount >= option.headcount ? 'opacity-75' : ''
                  }`}
                >
                  <div>{option.label}</div>
                  <div>
                    {option.filledHeadcount >= option.headcount ? (
                      <span className="badge bg-danger me-2">
                        {i18n.language === 'ar' ? 'غير متاح' : 'Not Available'}
                      </span>
                    ) : null}
                    <span className="text-muted small">{option.filledHeadcount + '/' + option.headcount}</span>
                  </div>
                </div>
              )}
              getOptionDisabled={option => option.filledHeadcount >= option.headcount}
            />
            {errors.positionId && touched.positionId && <div className="invalid-feedback d-block">{errors.positionId}</div>}
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label fw-semibold">{t('group')}</label>
            <Select
              classNamePrefix="react-select"
              isSearchable={true}
              name="personGroupId"
              options={Group.list}
              onChange={option => setFieldValue('personGroupId', option.value)}
              value={Group.list?.find(f => f.value === values.personGroupId)}
              placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
              className={errors.personGroupId && touched.personGroupId ? 'is-invalid' : ''}
            />
            {errors.personGroupId && touched.personGroupId && (
              <div className="invalid-feedback d-block">{errors.personGroupId}</div>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label fw-semibold">{t('Grade')}</label>
            <Select
              classNamePrefix="react-select"
              isSearchable={true}
              name="gradeId"
              options={Grade.list}
              onChange={option => setFieldValue('gradeId', option.value)}
              value={Grade.list?.find(f => f.value === values.gradeId)}
              placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
              className={errors.gradeId && touched.gradeId ? 'is-invalid' : ''}
            />
            {errors.gradeId && touched.gradeId && <div className="invalid-feedback d-block">{errors.gradeId}</div>}
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label fw-semibold">{t('SuperVisor')}</label>
            <Select
              classNamePrefix="react-select"
              isSearchable={true}
              name="supervisorId"
              options={SuperVisor.list}
              onChange={option => setFieldValue('supervisorId', option.value)}
              value={SuperVisor.list?.find(f => f.value === values.supervisorId)}
              placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
              className={errors.supervisorId && touched.supervisorId ? 'is-invalid' : ''}
            />
            {errors.supervisorId && touched.supervisorId && (
              <div className="invalid-feedback d-block">{errors.supervisorId}</div>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label fw-semibold">{t('Payroll')}</label>
            <Select
              classNamePrefix="react-select"
              isSearchable={true}
              name="payrollId"
              options={Payroll.list}
              onChange={option => setFieldValue('payrollId', option.value)}
              value={Payroll.list?.find(f => f.value === values.payrollId)}
              placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
              className={errors.payrollId && touched.payrollId ? 'is-invalid' : ''}
            />
            {errors.payrollId && touched.payrollId && <div className="invalid-feedback d-block">{errors.payrollId}</div>}
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label fw-semibold">{t('Status')}</label>
            <Select
              classNamePrefix="react-select"
              isSearchable={true}
              name="assignmentStatusTypeId"
              options={Status.list}
              onChange={option => setFieldValue('assignmentStatusTypeId', option.value)}
              value={Status.list?.find(f => f.value === values.assignmentStatusTypeId)}
              placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
              className={errors.assignmentStatusTypeId && touched.assignmentStatusTypeId ? 'is-invalid' : ''}
            />
            {errors.assignmentStatusTypeId && touched.assignmentStatusTypeId && (
              <div className="invalid-feedback d-block">{errors.assignmentStatusTypeId}</div>
            )}
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">{t('Start Date')}</label>
            <Form.Control
              type="date"
              className={errors.startDate && touched.startDate ? 'is-invalid' : ''}
              name="startDate"
              onChange={formik.handleChange}
              value={formik.values.startDate}
            />
            {formik.errors.startDate && formik.touched.startDate && (
              <div className="invalid-feedback d-block">{formik.errors.startDate}</div>
            )}
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">{t('End_Date')}</label>
            <Form.Control
              type="date"
              className={formik.errors.endDate && formik.touched.endDate ? 'is-invalid' : ''}
              name="endDate"
              onChange={formik.handleChange}
              value={formik.values.endDate}
            />
            {formik.errors.endDate && formik.touched.endDate && (
              <div className="invalid-feedback d-block">{formik.errors.endDate}</div>
            )}
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <button
                  onClick={() => Navigate('/HR/Employees', { replace: true })}
                  type="button"
                  className="btn btn-outline-secondary"
                >
                  <i className="fas fa-arrow-left me-2"></i>
                  {t('Cancel')}
                </button>
              </div>
              
              <div>
                {(isCurrent || isCurrent === undefined) && (
                  <>
                    {allAssignment?.length > 0 && (
                      <>
                        {HasPermission('EditHrPerAssignment') && (
                          <button 
                            onClick={e => handleUpdateAssignment(e)} 
                            type="button" 
                            className="btn btn-warning me-2"
                          >
                            <i className="fas fa-edit me-2"></i>
                            {t('Edit_Aassignment')}
                          </button>
                        )}
                      </>
                    )}
                  </>
                )}
                
                {(isCurrent || isCurrent === undefined) && HasPermission('AddHrPerAssignment') && (
                  <button onClick={formik.handleSubmit} type="button" className="btn btn-primary">
                    <i className="fas fa-plus-circle me-2"></i>
                    {t('NewAssignments')}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
}

export default AssignmentForm;
